import React, { useState, useEffect } from "react";
import DuaCard from "./DuaCard";
import Header from "./Header";

import FirstVisit from "./FirstVisit";

function CardWrapper() {
  const [duas, setDuas] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    // Fetch duas from JSON
    fetch("/duas.json")
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setDuas(data);
          localStorage.setItem("duas", JSON.stringify(data));
        } else {
          const localDuas = JSON.parse(localStorage.getItem("duas"));
          if (Array.isArray(localDuas)) setDuas(localDuas);
        }
      });

    // Check if it's the first visit
    const firstVisit = localStorage.getItem("firstVisit");
    if (!firstVisit) setIsFirstVisit(true);

    // Check if the device is mobile
    const checkIfMobile = () => {
      if (window.innerWidth <= 768) setIsMobile(true);
      else setIsMobile(false);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const handleContinue = () => {
    window.scrollTo(0, 0);
    setIsFirstVisit(false);
    isMobile && localStorage.setItem("firstVisit", "true");
  };

  if (isMobile && isFirstVisit) {
    return (
      <FirstVisit
        handleContinue={handleContinue}
        setIsFirstVisit={setIsFirstVisit}
      />
    );
  }

  console.log({ duas });
  
  
  const categories = [...new Set(duas?.map((dua) => dua.category))];
  
  console.log({categories});
  return (
    <div className="w-full items-center flex flex-col my-8">
      <div className="relative flex flex-col items-center  md:max-w-[615px] w-full p-3">
        <Header />

        <div className="mt-8 flex  flex-col gap-6">
          {categories?.map((category, idx) => (
            <div key={"cat" + idx} className="flex flex-col gap-6">
              <p className="text-lg w-full text-center tracking-wider uppercase font-[ClashDisplay-Medium] ">
                {category}
              </p>
              {duas
                ?.filter((dua) => dua.category === category)
                .map((dua, idx) => (
                  <DuaCard key={idx} dua={{ ...dua, id: idx }}></DuaCard>
                ))}
            </div>

          ))}
        </div>
      </div>
    </div>
  );
}

export default CardWrapper;
